// Import model
import { AppointmentFieldOptions } from '../models/AppointmentFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AppointmentFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class AppointmentFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a AppointmentFieldOptions instance
   */
  static deserialize(json: string): AppointmentFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AppointmentFieldOptions instance
   */
  static fromObject(obj: any): AppointmentFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AppointmentFieldOptions');
    }


    const instance: AppointmentFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _91E71312: obj['_91e71312'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AppointmentFieldOptions instances
   */
  static deserializeArray(json: string): AppointmentFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AppointmentFieldOptions instance to a JSON string
   */
  static serialize(instance: AppointmentFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AppointmentFieldOptions instance to a plain object
   */
  static toObject(instance: AppointmentFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_91e71312': instance._91E71312,
    };
  }

  /**
   * Serializes an array of AppointmentFieldOptions instances to a JSON string
   */
  static serializeArray(instances: AppointmentFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
